import { render, staticRenderFns } from "./SanityEnglishV2.vue?vue&type=template&id=372ee47f&"
import script from "./SanityEnglishV2.vue?vue&type=script&lang=js&"
export * from "./SanityEnglishV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports